import { render, staticRenderFns } from "./ConfigurationPanel.vue?vue&type=template&id=830e2ac4&"
import script from "./ConfigurationPanel.vue?vue&type=script&lang=js&"
export * from "./ConfigurationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports